// extracted by mini-css-extract-plugin
export default {"tabs":"_3i-2Vv-iTTAxvcdjXIKKI_","hideNavItems":"_3tjv7H4l7xbnGPZu3mODex"};